import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export interface BadgePolicyCardProps {
  title: string;
  children: React.ReactNode;
}

export function BadgePolicyCard(props: BadgePolicyCardProps) {
  const { title, children } = props;

  return (
    <Stack
      spacing={3}
      sx={{
        backgroundColor: (theme) => theme.palette.secondary.main,
        borderRadius: (theme) => theme.borderRadius?.small,
        boxShadow: (theme) => theme.shadows[2],
      }}
      py={6}
      px={5}
      mx={4}
    >
      <Text bold variant="h5">
        {title}
      </Text>

      {children}
    </Stack>
  );
}
